<template>
    <div class="main">
        <!-- 頁首 -->
        <Header :title="title" :isBack="true" />
        <!-- 主體 -->
        <div class="mainContent">

            <!-- 農業情報站 -->
            <div>
                <!-- 作物預期採收模組 -->
                <div :class="group_menu.weather_info.style" class="w3-container w3-padding-16" @click="goPwaWeatherInfo()">
                    <div class="w3-left"><i :class="group_menu.weather_info.icon" class="fa-solid w3-xxxlarge"></i></div>
                    <div class="w3-right">
                        <h3><i class="fa-solid fa-angle-right"></i></h3>
                    </div>
                    <div class="w3-clear"></div>
                    <h4>{{ group_menu.weather_info.title }}</h4>
                </div>
                <!-- 颱風淹水潛勢專區 -->
                <div :class="group_menu.typhoon_flood.style" class="w3-container w3-padding-16" @click="goPwaTyphoonFlood()">
                    <div class="w3-left"><i :class="group_menu.typhoon_flood.icon" class="fa-solid w3-xxxlarge"></i></div>
                    <div class="w3-right">
                        <h3><i class="fa-solid fa-angle-right"></i></h3>
                    </div>
                    <div class="w3-clear"></div>
                    <h4>{{ group_menu.typhoon_flood.title }}</h4>
                </div>
                <!-- 雲林淹水潛勢專區 -->
                <div :class="group_menu.yunlin_flood.style" class="w3-container w3-padding-16" @click="goPwaYunlinFlood()">
                    <div class="w3-left"><i :class="group_menu.yunlin_flood.icon" class="fa-solid w3-xxxlarge"></i></div>
                    <div class="w3-right">
                        <h3><i class="fa-solid fa-angle-right"></i></h3>
                    </div>
                    <div class="w3-clear"></div>
                    <h4>{{ group_menu.yunlin_flood.title }}</h4>
                </div>
            </div>
 
        </div>
    </div>
</template>
<script>
import Header from '@/components/pwa/Header.vue'
export default {
    created() {
        window.vue = this;
        if(!window.checkLogin()){ window.setPage("login");}                  
    },  
    components: {
        Header
    },
    data(){
        return {
            //標題
            title: "氣候變遷",
            //群組(選單)
            group_menu:{
                title:"選單", 
                weather_info:{
                    style:"w3-teal",
                    title:"作物預期採收模組",
                    icon:"fa-area-chart"
                },
                typhoon_flood:{
                    style:"w3-indigo",
                    title:"颱風淹水潛勢專區",
                    icon:"fa-line-chart"
                },
                yunlin_flood:{
                    style:"w3-dark-grey",
                    title:"雲林淹水潛勢專區",
                    icon:"fa-map"
                }
            },
        }
    },
    methods: {
        //前往 首頁
        goHome:function(){ window.setPage("home"); },
        //前往 作物預期採收模組
        goPwaWeatherInfo() { window.location = "pwa.html#/PwaWeatherInfo"; },
        //前往 颱風淹水潛勢專區
        goPwaTyphoonFlood() { window.location = "pwa.html#/PwaTyphoonFlood"; },
        //前往 雲林淹水潛勢專區
        goPwaYunlinFlood() { window.location = "pwa.html#/PwaYunlinFlood"; },     
    }
}
</script>